import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add schedule API
   * @param {any} data - The schedule data to add
   * @returns {any} A promise that resolves with the response
   */
  addSchedule: (data: any): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/partner/v1/charging-schedule`, data, false);
  },
  /**
   * Fetch schedule API
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the schedules
   */
  fetchSchedules: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/partner/v1/charging-schedule`, {
      ...parameters,
    });
  },
  /**
   * Fetch schedule API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchSchedulesExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/partner/v1/charging-schedule/export-data`, {
      ...parameters,
    });
  },
  /**
   * Edit schedule API
   * @param {any} id - The schedule ID to edit
   * @param {any} data - The updated schedule data
   * @returns {any} A promise that resolves with the response
   */
  editSchedule: (id: number | string | null, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/partner/v1/charging-schedule/${id}`,
      data,
      false,
    );
  },

  /**
   * Fetch approved station API
   * @returns {any} A promise that resolves with the list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/partner/v1/charging-schedule/list-filters`);
  },
};
